<template>
  <h2 class="section-title">
    <span class="section-title__accent" aria-hidden="true"></span>
    <slot />
  </h2>
</template>

<script>
  export default {
    name: "SectionTitle",
  };
</script>

<style scoped lang="scss">
  .section-title {
    font-size: 34px;
    font-weight: 700;
    line-height: 1.25;
    letter-spacing: -0.01em;

    @media (max-width: 780px) {
      font-size: 28px;
      line-height: 1.3;
    }
  }

  .section-title__accent {
    display: block;
    width: 36px;
    height: 3px;
    background: #f40612;
    border-radius: 2px;
    margin-bottom: 14px;
  }
</style>
